<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     订单详情
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="expense-order-detail mb-md">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
      <div class="toolbox">&nbsp;</div>
    </div>

    <el-alert v-if="order.pay_status === 1" type="success" :closable="false">
      <template slot="title">
        <p>订单状态： 交易成功</p>
      </template>
    </el-alert>

    <el-alert v-if="order.pay_status === 0" type="warning" :closable="false">
      <template slot="title">
        <p v-if="order.pay_type === 3">
          <span v-if="!order.billed">本订单为月结货款订单，账单生成日期： 次月1日，还款截止日期： 次月10日</span>
          <span v-else>
            账单已出，还款截止日期： 本月10日
            <el-button size="mini" type="warning" @click="toBill">账单付款</el-button>
          </span>
        </p>
        <p v-else>
          <span>订单状态： 等待买家付款</span>
          <span class="span"><el-button size="mini" type="warning" @click="toCasher">去支付</el-button></span>
        </p>
      </template>
    </el-alert>

    <el-alert v-if="order.pay_status === 2 && order.payment_type === 1" type="info">
      <template slot="title">
        <div class="flex">
          <p class="mr-lg">请您按照如下信息尽快完成转账汇款</p>
          <p style="color: #07c160;cursor: pointer;" @click="toCasher">更换支付方式</p>
        </div>
        <p style="margin-top: 0px;">
          <span>开户银行：</span>
          <span class="span text-danger">{{ zzpay.bank }}</span>
        </p>
        <p>
          <span>银行账号：</span>
          <span class="span text-danger">{{ zzpay.bank_account }}</span>
        </p>
        <p>
          <span>公司全称：</span>
          <span class="span text-danger">{{ zzpay.corporate_name }}</span>
        </p>
      </template>
    </el-alert>

    <el-card v-loading="loading" class="display-info mt-md" shadow="never">
      <el-row>
        <el-col :span="20" class="flex">
          <span class="text-muted">订单主题：</span>
          <span class="span">{{ order.subject }}</span>
          <div class="ml-sm order-tag-area">
            <div v-for="(tag,tagIndex) in order.order_tags" :key="tagIndex" class="tag mr-sm">{{ tag }}</div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <span class="text-muted">订单编号：</span>
          <span class="span">{{ order.order_sn }}</span>
        </el-col>
        <el-col :span="6">
          <span class="text-muted">订单类型：</span>
          <span class="span">{{ $store.getters.orderTypeObj[order.order_type] }}</span>
        </el-col>
        <el-col :span="6">
          <span class="text-muted">创建时间：</span>
          <span class="span">{{ order.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
        </el-col>
        <el-col :span="6">
          <template v-if="order.pay_status === 1">
            <span class="text-muted">支付时间：</span>
            <span class="span">{{ order.pay_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
          <template v-else>
            <span><el-button v-if="order.referer != 0" type="text" @click="closeOrder">取消订单</el-button></span>
          </template>
        </el-col>
      </el-row>
      <el-collapse>
        <el-collapse-item name="pay">
          <template slot="title">
            <div class="collapse-header">
              <span class="text-muted">支付信息： </span>
              <span class="span" :class="{ 'text-warning': order.pay_status !== 1 }">{{ $store.getters.payStatusObj[order.pay_status] }}</span>
            </div>
          </template>
          <div>
            <el-row>
              <el-col :span="6">
                <span class="text-muted">结算类型： </span>
                <span class="span">{{ $store.getters.payTypeObj[order.pay_type] }}</span>
              </el-col>
              <el-col :span="6">
                <span class="text-muted">支付方式： </span>
                <span class="span">{{ $store.getters.paymentTypeObj[order.payment_type] }}</span>
              </el-col>
              <el-col :span="6">
                <span class="text-muted">支付流水号： </span>
                <span class="span">{{ order.paylog_no }}</span>
              </el-col>
              <el-col :span="6">
                <span class="text-muted">支付完成时间： </span>
                <span class="span">{{ order.pay_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item name="shipping">
          <template slot="title">
            <div class="collapse-header">
              <span class="text-muted">物流信息： </span>
              <span v-if="order.shippingid === -1" class="span">无需快递</span>
              <span v-else class="span">{{ $store.getters.shippingStatusObj[order.shipping_status] }}</span>
            </div>
          </template>
          <div v-if="order.shippingid > 0">
            <el-row>
              <el-col :span="6">
                <span class="text-muted">快递公司： </span>
                <span class="span">{{ shipping.post_com_name }}</span>
              </el-col>
              <el-col :span="6">
                <span class="text-muted">快递单号： </span>
                <span class="span">{{ shipping.post_sn }}</span>
              </el-col>
              <el-col :span="6">
                <span class="text-muted">发货时间： </span>
                <span class="span">{{ shipping.taketime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <span class="text-muted">配送地址： </span>
                <span class="span">
                  {{ shipping.to_province }}
                  {{ shipping.to_city }}
                  {{ shipping.to_district }}
                  {{ shipping.to_address }}
                </span>
              </el-col>
              <el-col :span="6">
                <span class="text-muted">收件人： </span>
                <span class="span">
                  {{ shipping.to_contact_man }}&nbsp;&nbsp;&nbsp;&nbsp;
                  {{ shipping.to_contact_num }}
                </span>
              </el-col>
              <el-col :span="6">
                <span class="text-muted">签收时间： </span>
                <span class="span">{{ shipping.signtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </el-col>
            </el-row>
          </div>
          <div v-else><span>暂无物流信息！</span></div>
        </el-collapse-item>
        <el-collapse-item v-if="order.pay_status === 1" name="invoice">
          <template slot="title">
            <div class="collapse-header">
              <span class="text-muted">发票信息： </span>
              <span v-if="order.invoiced === -1" class="span">暂无记录</span>
              <span v-if="order.invoiced === 0" class="span text-primary" role="button" @click.stop="applyOinvoice">申请发票</span>
              <span v-if="order.invoiced > 0" class="span">{{ $store.getters.orderInvoiceStatusObj[oinvoice.invoice_status] }}</span>
            </div>
          </template>
          <div v-if="order.invoiced > 0">
            <el-row>
              <el-col :span="6">
                <span class="text-muted">申请时间： </span>
                <span class="span">{{ oinvoice.applytime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </el-col>
              <el-col :span="6">
                <span class="text-muted">发票抬头： </span>
                <span class="span">{{ oinvoice.corporate_name }}</span>
              </el-col>
              <el-col :span="6">
                <span class="text-muted">税号： </span>
                <span class="span">{{ oinvoice.corporate_code }}</span>
              </el-col>
            </el-row>
          </div>
          <div v-else><span>暂无发票信息！</span></div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-card v-loading="loading" class="mt-md" shadow="never">
      <el-table
        ref="listTable"
        class="padding-small"
        :data="items"
        style="width: 100%">
        <el-table-column type="index" width="50" align="center" />
        <el-table-column width="100" align="center">
          <template slot-scope="scope">
            <f-image class="avatar" :src="scope.row.item_thumb" />
          </template>
        </el-table-column>
        <el-table-column label="明细" min-width="300" show-overflow-tooltip>
          <div slot-scope="scope" class="flex">
            {{ scope.row.item_title }}
            <div class="ml-sm order-tag-area">
              <div v-for="(tag,tagIndex) in scope.row.item_tags" :key="tagIndex" class="tag mr-sm">{{ tag }}</div>
            </div>
          </div>
        </el-table-column>
        <el-table-column label="数量" min-width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.num }}</span>
            <span class="font-sm text-muted"> {{ scope.row.unit ? scope.row.unit : '件' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="单价" min-width="100" align="right">
          <template slot-scope="scope">
            <span>￥{{ scope.row.price }}</span>
            <span v-if="Number(scope.row.face_price) > Number(scope.row.price)" class="text-muted ml-sm" style="font-size: 12px;text-decoration: line-through;">￥{{ scope.row.face_price }}</span> 
          </template>
        </el-table-column>
        <el-table-column label="金额小计" min-width="100" align="right">
          <template slot-scope="scope">
            <span class="span">{{ scope.row.fee | currency }}</span>
          </template>
        </el-table-column>
        <template slot="append">
          <f-table-footer>
            <template slot="right">
              <div class="pay-item">
                <span>总计金额：</span>
                <span class="span">{{ order.product_amount_total | currency }}</span>
              </div>
              <div v-if="discount" class="pay-item">
                <span>优惠金额：</span>
                <span class="span text-danger">-{{ discount | currency }}</span>
              </div>
              <div v-if="order.pay_status === 1" class="pay-item">
                <span>实付金额：</span>
                <span class="span text-success">{{ order.order_amount_payed | currency }}</span>
              </div>
              <div v-else class="pay-item">
                <span>应付金额：</span>
                <span class="span text-warning">{{ order.order_amount_total | currency }}</span>
              </div>
              <div v-if="balance" class="text-muted text-right">
                <span>（余额支付：</span>
                <span class="span font-md">{{ paylog.opl_credit_fee | currency }}</span>
                <span>）</span>
              </div>
            </template>
          </f-table-footer>
        </template>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import FTableFooter from '@/components/FTableFooter'
import { getOrderDetailApi, cancelOrderApi } from '@/api/expense/expenseOrderApi'
export default {
  name: 'ExpenseOrderDetail',
  components: {
    FTableFooter
  },
  data() {
    return {
      loading: false,
      orderid: this.$route.query.orderid,
      order: {},
      items: [],
      bill: {},
      oinvoice: {},
      contract: {},
      shipping: {},
      paylog: {},
      zzpay: {},
      discount: 0,
    }
  },
  computed: {
    balance() {
      return parseFloat(this.paylog.opl_credit_fee)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      getOrderDetailApi(this.orderid).then(res => {
        this.loading = false
        if (!res.errno) {
          const order_tags = res.data.order.order_tag != '' ? res.data.order.order_tag.split(',') : []
          this.order = Object.assign({}, res.data.order,{order_tags})
          this.items = res.data.items
          if(this.items.length > 0) {
            this.items = this.items.map(item => {
              item.item_tags = item.item_tags.filter(e => e !== '')
              return item
            })
          }
          this.discount = this.order.product_amount_total - this.order.order_amount_total

          this.bill = Object.assign({}, res.data.bill)
          this.paylog = Object.assign({}, res.data.paylog)
          this.oinvoice = Object.assign({}, res.data.oinvoice)
          this.contract = Object.assign({}, res.data.contract)
          this.shipping = Object.assign({}, res.data.shipping)
          if (res.data.zzpay) {
            this.zzpay = Object.assign({}, res.data.zzpay)
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    closeOrder() {
      this.$confirm(`将取消订单，是否继续？`, '提示', {
        type: 'warning'
      }).then(() => {
        cancelOrderApi({ orderid: this.orderid }).then(res => {
          if (!res.errno) {
            this.$message.success('操作成功！')
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      })
    },
    toBill() {
      this.$router.push('/expense/bill/detail?billid=' + this.order.billed)
    },
    toCasher() {
      this.$router.push('/expense/order/cashier')
      localStorage.setItem("__ORDERID__", this.orderid);
    },
    applyOinvoice() {
      this.$router.push('/expense/invoice/apply')
    }
  }
}
</script>

<style lang="scss" scoped>
.expense-order-detail {
  .order-tag-area {
    display: flex;
    align-items: center;
    .tag {
      height: 20px;
      line-height: 20px;
      border-radius: 4px;
      // background-color: rgba(242, 150, 25, 1);
      background: linear-gradient(91.06deg, rgba(254,167,44,1) 3.04%,rgba(253,120,34,1) 101.6%);
      color: rgba(255, 255, 255, 1);
      font-size: 12px;
      text-align: center;
      font-style: italic;
      padding: 0 10px;
      font-weight: 700;
    }
  }
  .pay-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 200px;
  }
}
</style>